import join from '../images/join.jpg'
import '../components/css components/join.css';
import React, { useEffect } from 'react';
import WOW from 'wowjs';

function Join(){
    useEffect(() => {
        const wow = new WOW.WOW({
          live: false
        });
        wow.init();
      }, []);
    return(
        <div className='join' id='#join'>
              <img src={join} alt='join us'/>
                <div className='contain  wow slideInLeft' data-wow-duration="2s" data-wow-delay=".4s">
                        <p className='animate__animated animate__backInLeft'><a href='https://docs.google.com/forms/d/e/1FAIpQLScPqeUUckNUPCGVK2hm4mkHa23af-xgfGT9N2lLPYbkZaPlIw/viewform ' target="_blank">Click Here </a>
                        <h2 className='animate__animated animate__backInLeft'>& Join us now!</h2></p>
                </div>
        </div>
    );
}

export default Join;